<template>
  <q-layout
    class="layout-main"
    :view="view"
  >
    <AppNavBar />

    <q-no-ssr>
      <COverlay
        v-if="layoutOverlay && isMounted"
        v-model="layoutOverlay"
      />
      <template v-if="appNavBarDrawerCp">
        <q-drawer
          v-if="$q.screen.lt.md && isMounted"
          v-model="layoutDrawer"
          :breakpoint="$q.screen.sizes.md"
          no-swipe-close
          no-swipe-open
          overlay
          persistent
          side="right"
          unelevated
          :width="$q.screen.width"
        >
          <component :is="appNavBarDrawerCp" />
        </q-drawer>
      </template>
    </q-no-ssr>

    <q-page-container
      data-allow-mismatch
      style="padding-top: 56px"
    >
      <suspense>
        <PageError
          v-if="pageNotFound"
          :status="404"
        />
        <router-view v-else />
      </suspense>
    </q-page-container>

    <q-footer
      ref="elQFooter"
      class="layout-main-footer"
      :height-hint="0"
    >
      <div class="layout-main-footer__head">
        <!-- use teleport -->
      </div>

      <div class="layout-main-footer__body">
        <!-- use teleport -->
      </div>

      <div class="layout-main-footer__foot">
        <!-- use teleport -->
      </div>
    </q-footer>
  </q-layout>
</template>

<script setup lang="ts">
import { useMounted } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { computed, defineAsyncComponent } from 'vue'
import { useRoute } from 'vue-router'

import { useAppStore } from '@/stores/modules/app'
import { useThemeStore } from '@/stores/modules/theme'

const route = useRoute()

const isMounted = useMounted()

const { pageNotFound } = storeToRefs(useAppStore())
const { elQFooter, layoutDrawer, layoutOverlay } = storeToRefs(useThemeStore())

const appNavBarDrawerCp = computed(() =>
  layoutDrawer.value
    ? defineAsyncComponent(
        () => import('@/components/AppCommon/AppNavBarDrawer.vue'),
      )
    : null,
)

const AppNavBar = defineAsyncComponent(
  () => import('@/components/AppCommon/AppNavBar.vue'),
)

const COverlay = defineAsyncComponent(() => import('@/components/COverlay.vue'))
const PageError = defineAsyncComponent(() => import('@/pages/PageError.vue'))

const view = computed(() => {
  switch (route.name) {
    case 'listing':
      return 'hhh lpr lFr'

    default:
      return 'hHh lpr fFf'
  }
})
</script>

<style lang="scss">
@use 'sass:map';

.layout-main {
  .layout-main-footer {
    background: white;
    border-radius: map.get($radius-sizes, 'md') map.get($radius-sizes, 'md') 0 0;
    box-shadow: 0 -4px 20px 10px rgb(219 225 245 / 35%);
  }

  .layout-main-footer__body {
    box-sizing: content-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    .q-btn {
      width: 100%;
      min-width: 0;
      min-height: 0;
      padding: 0.8rem;
      margin: 0.5rem;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.6;
      border-radius: map.get($radius-sizes, 'xl');
    }
  }
}

.layout-main.overlay {
  .q-overlay {
    background-color: $backdropOverlay !important;
  }

  .q-footer {
    z-index: 1;
  }
}
</style>
